import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';

export const loginGuardFn: CanActivateFn = async () => {
  const router = inject(Router)
  const store = inject(Store)

  const isTokenValid = store.selectSnapshot(UserContextSelectors.isAuthenticated)

  return !isTokenValid || router.createUrlTree(['/start'])
};
